import { useEffect, useMemo, useState } from 'react'
import { useQuery } from 'react-query'
import CreateUpdatePlanBTFormView, { FormData, ValidationFormDataPlanBT } from './CreateUpdatePlanBTFormView/CreateUpdatePlanBTFormView'

import { usePlanBT, useSinglePlanBT } from '../../../hooks'
import { PlanBTPatch } from '../../../types/planBT.types'
import { isErrorPlanBTCheck } from '../../../utils/validationPlanBTCheck'
import { FileUrl } from '../../../../../common/components/molecule/FileListManager/FileListManager'
import { useNavigate } from 'react-router-dom'
import fileAPI from '../../../../../services/fileAPI'
import { planBTAPI } from '../../../services/planAPI'


export default function CreateUpdatePlanBTFormPresenter({isUpdate}:{isUpdate?: boolean}) {

    const [data, setData] = useState<FormData>({})
    const [file, setFile] = useState<FileUrl[] | null>(null)
    const [errorForm, setErrorForm] = useState<ValidationFormDataPlanBT | null>(null)


    const {createNewPlanBT} = usePlanBT()
    const {singlePlanBTQuery, updatePlanBT} = useSinglePlanBT()

    const allPlansQuery = useQuery({
        queryKey: ['allPlanBTForExclusion'],
        queryFn: () => planBTAPI.getAllPlanBT(0, 0),
        staleTime: 60 * 1000,
    })

    const excludeMinigridIds = useMemo(() => {
        const currentPlanId = singlePlanBTQuery.data?.plan_id
        return (allPlansQuery.data?.data ?? [])
            .filter((p) => p.plan_id !== currentPlanId && Boolean(p.plan_minigrid))
            .map((p) => p.plan_minigrid)
    }, [allPlansQuery.data, singlePlanBTQuery.data])

    const navigate = useNavigate()

    const convertFormDataToPlanBT = (data: FormData ): PlanBTPatch => {

        return {
            plan_name: data.name || undefined,
            plan_description: data.description || undefined,
            plan_minigrid : data.minigrid?.minigrid_id || undefined
        }
    }


    useEffect(() => {
        if (isUpdate && singlePlanBTQuery.data) {
            setData({
                name: singlePlanBTQuery.data.plan_name,
                description: singlePlanBTQuery.data.plan_description,
                initMinigridId: singlePlanBTQuery.data.plan_minigrid
                
            })

            if (singlePlanBTQuery.data.plan_image_file_id) {
                const FileUrl : FileUrl = new File([], 'file')
                setFile( [
                    {...FileUrl,
                    type: "image",
                    url: fileAPI.getFilesURL(singlePlanBTQuery.data.plan_image_file_id)
                }
                ])
            }
        }
    }, [singlePlanBTQuery.data, isUpdate])

    const onSubmit = () => {
        const dataFormated =  convertFormDataToPlanBT(data)
          //Check
          const isError = isErrorPlanBTCheck(dataFormated, file?.[0] || null)
         
       
          if (isError) {
              setErrorForm(isError)

              return
          }
        if(!isUpdate){
  
  
      
      

 
            setErrorForm(null)
            //Create
            createNewPlanBT.mutate({
                plan: dataFormated,
                file: file?.[0] ||undefined,
                callbackFunc: ({result}) => {
                    if(result){
                        setData({})
                        setFile(null)
                        navigate(-1)

                    }
                }
            })

            return
        }else{
       
            const dataToSend = {...singlePlanBTQuery.data, ...dataFormated}
            updatePlanBT.mutate({
                plan: dataToSend,
                file: file?.[0] || undefined,
                callbackFunc: ({result}) => {
                    if(result){
                        navigate(-1)
                    }
                }
            })
            
        }



    }
    if (isUpdate && singlePlanBTQuery.isLoading) {
        return <p>loading...</p>
    }
  return (
    <CreateUpdatePlanBTFormView
        setData={setData}
        data={data}
        setImages={setFile}
        imageList={file ||[] }
        labelSubmitBtn={!isUpdate ? 'Créer' : 'Modifier'}
        onSubmit={onSubmit}
        isErrorInput={errorForm || undefined}
        isLoading={createNewPlanBT.isLoading || updatePlanBT.isLoading}
        excludeMinigridIds={excludeMinigridIds}
        />
  )
}

